var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" "+_vm._s(_vm.$t('You have been assigned to the following [CURRICULUM_MAP]:'))+" "),_c('a',{attrs:{"href":'/Atlas/Develop/View/UnitCalendar?CurriculumMapID=' + _vm.notificationData.mapId + '&YearID=' + _vm.notificationData.yearId}},[_vm._v(" "+_vm._s(_vm.notificationData.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }